// api/Assistant_createquestion.js

import { ENV } from "../../Utils";

export const Assistant_createquestion = async (
  accessToken,
  threadId,
  assistantId,
  data,
) => {
  try {
    const url = new URL(
      `${ENV.BASE_API}/${ENV.API_ROUTES.THREADGETEDUCA}/${threadId}/${assistantId}`,
    );
    url.searchParams.append("data", data);

    const resp = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (!resp.ok) {
      const errorData = await resp
        .json()
        .catch(() => ({ message: resp.statusText }));
      throw new Error(
        `Error del servidor: ${resp.status} - ${errorData.message}`,
      );
    }

    // --- CORRECCIÓN CLAVE ---
    // Parseamos la respuesta completa a JSON.
    const result = await resp.json();

    // Y retornamos el objeto completo (que contiene la propiedad "messages").
    return result;
  } catch (error) {
    console.error("Error en la función Assistant_createquestion:", error);
    throw error;
  }
};
